/**
 * Client-side prompt translation — no API needed.
 * Detects French, German, Italian, or Spanish prompts via keyword heuristics,
 * then substitutes known words using a hardcoded dictionary.
 */

// ── Dictionaries ──────────────────────────────────────────────────────────────

const FR_DICT = {
  // Articles/prepositions
  'un ': 'a ', 'une ': 'a ', 'le ': 'the ', 'la ': 'the ', 'les ': 'the ',
  'de ': 'of ', "d'": 'of ', "l'": 'the ', 'et ': 'and ', 'avec ': 'with ',
  'sur ': 'on ', 'dans ': 'in ', 'en ': 'in ', 'au ': 'at the ', 'aux ': 'at the ',
  // Common art/design words
  'chat': 'cat', 'chien': 'dog', 'cheval': 'horse', 'loup': 'wolf', 'renard': 'fox',
  'dragon': 'dragon', 'tigre': 'tiger', 'lion': 'lion', 'aigle': 'eagle', 'hibou': 'owl',
  'cerf': 'deer', 'lapin': 'rabbit', 'ours': 'bear', 'dauphin': 'dolphin',
  'montagne': 'mountain', 'forêt': 'forest', 'foret': 'forest', 'mer': 'sea', 'océan': 'ocean',
  'ciel': 'sky', 'soleil': 'sun', 'lune': 'moon', 'étoile': 'star', 'nuit': 'night',
  'feu': 'fire', 'eau': 'water', 'glace': 'ice', 'nuage': 'cloud', 'vent': 'wind',
  'fleur': 'flower', 'rose': 'rose', 'arbre': 'tree', 'jardin': 'garden', 'herbe': 'grass',
  'ville': 'city', 'rue': 'street', 'pont': 'bridge', 'château': 'castle', 'chateau': 'castle',
  'robot': 'robot', 'vaisseau': 'spaceship', 'galaxie': 'galaxy', 'cosmos': 'cosmos',
  'rouge': 'red', 'bleu': 'blue', 'vert': 'green', 'noir': 'black', 'blanc': 'white',
  'doré': 'golden', 'dore': 'golden', 'violet': 'purple', 'orange': 'orange',
  'beau': 'beautiful', 'belle': 'beautiful', 'grand': 'large', 'petit': 'small',
  'ancien': 'ancient', 'moderne': 'modern', 'futuriste': 'futuristic', 'magique': 'magical',
  'sombre': 'dark', 'lumineux': 'bright', 'coloré': 'colorful', 'coloree': 'colorful',
  'artistique': 'artistic', 'détaillé': 'detailed', 'detaille': 'detailed',
  'cyberpunk': 'cyberpunk', 'néon': 'neon', 'neon': 'neon', 'rétro': 'retro', 'retro': 'retro',
  'guerrier': 'warrior', 'samurai': 'samurai', 'ninja': 'ninja', 'pirate': 'pirate',
  'sorcier': 'wizard', 'fée': 'fairy', 'fee': 'fairy', 'fantôme': 'ghost', 'fantome': 'ghost',
  'crâne': 'skull', 'crane': 'skull', 'squelette': 'skeleton',
};

const DE_DICT = {
  // Articles/prepositions
  'ein ': 'a ', 'eine ': 'a ', 'der ': 'the ', 'die ': 'the ', 'das ': 'the ',
  'und ': 'and ', 'mit ': 'with ', 'in ': 'in ', 'auf ': 'on ', 'von ': 'of ',
  'im ': 'in the ', 'am ': 'at the ',
  // Common art/design words
  'katze': 'cat', 'hund': 'dog', 'pferd': 'horse', 'wolf': 'wolf', 'fuchs': 'fox',
  'drache': 'dragon', 'tiger': 'tiger', 'löwe': 'lion', 'loewe': 'lion', 'adler': 'eagle',
  'eule': 'owl', 'bär': 'bear', 'baer': 'bear', 'hirsch': 'deer', 'hase': 'rabbit',
  'delphin': 'dolphin', 'hai': 'shark',
  'berg': 'mountain', 'wald': 'forest', 'meer': 'sea', 'ozean': 'ocean', 'see': 'lake',
  'himmel': 'sky', 'sonne': 'sun', 'mond': 'moon', 'stern': 'star', 'nacht': 'night',
  'feuer': 'fire', 'wasser': 'water', 'eis': 'ice', 'wolke': 'cloud', 'wind': 'wind',
  'blume': 'flower', 'rose': 'rose', 'baum': 'tree', 'garten': 'garden',
  'stadt': 'city', 'straße': 'street', 'strasse': 'street', 'brücke': 'bridge', 'bruecke': 'bridge',
  'schloss': 'castle', 'turm': 'tower',
  'roboter': 'robot', 'raumschiff': 'spaceship', 'galaxie': 'galaxy',
  'rot': 'red', 'blau': 'blue', 'grün': 'green', 'gruen': 'green', 'schwarz': 'black',
  'weiß': 'white', 'weiss': 'white', 'golden': 'golden', 'lila': 'purple',
  'schön': 'beautiful', 'schoen': 'beautiful', 'groß': 'large', 'gross': 'large', 'klein': 'small',
  'alt': 'ancient', 'modern': 'modern', 'futuristisch': 'futuristic', 'magisch': 'magical',
  'dunkel': 'dark', 'hell': 'bright', 'bunt': 'colorful', 'farbenfroh': 'colorful',
  'künstlerisch': 'artistic', 'detailliert': 'detailed',
  'cyberpunk': 'cyberpunk', 'neon': 'neon', 'retro': 'retro',
  'krieger': 'warrior', 'samurai': 'samurai', 'ninja': 'ninja', 'pirat': 'pirate',
  'zauberer': 'wizard', 'fee': 'fairy', 'gespenst': 'ghost', 'schädel': 'skull', 'schaedel': 'skull',
};

const IT_DICT = {
  // Articles/prepositions
  'un ': 'a ', 'una ': 'a ', 'il ': 'the ', 'la ': 'the ', 'lo ': 'the ', 'i ': 'the ',
  'le ': 'the ', 'gli ': 'the ', "dell'": 'of the ', "dell'": 'of the ',
  'e ': 'and ', 'con ': 'with ', 'in ': 'in ', 'su ': 'on ', 'di ': 'of ',
  // Common art/design words
  'gatto': 'cat', 'cane': 'dog', 'cavallo': 'horse', 'lupo': 'wolf', 'volpe': 'fox',
  'drago': 'dragon', 'tigre': 'tiger', 'leone': 'lion', 'aquila': 'eagle', 'gufo': 'owl',
  'orso': 'bear', 'cervo': 'deer', 'coniglio': 'rabbit', 'delfino': 'dolphin',
  'montagna': 'mountain', 'foresta': 'forest', 'mare': 'sea', 'oceano': 'ocean',
  'cielo': 'sky', 'sole': 'sun', 'luna': 'moon', 'stella': 'star', 'notte': 'night',
  'fuoco': 'fire', 'acqua': 'water', 'ghiaccio': 'ice', 'nuvola': 'cloud', 'vento': 'wind',
  'fiore': 'flower', 'rosa': 'rose', 'albero': 'tree', 'giardino': 'garden',
  'città': 'city', 'citta': 'city', 'strada': 'street', 'ponte': 'bridge',
  'castello': 'castle', 'torre': 'tower',
  'robot': 'robot', 'astronave': 'spaceship', 'galassia': 'galaxy',
  'rosso': 'red', 'blu': 'blue', 'verde': 'green', 'nero': 'black', 'bianco': 'white',
  'dorato': 'golden', 'viola': 'purple', 'arancione': 'orange',
  'bello': 'beautiful', 'bella': 'beautiful', 'grande': 'large', 'piccolo': 'small',
  'antico': 'ancient', 'moderno': 'modern', 'futuristico': 'futuristic', 'magico': 'magical',
  'scuro': 'dark', 'luminoso': 'bright', 'colorato': 'colorful',
  'artistico': 'artistic', 'dettagliato': 'detailed',
  'cyberpunk': 'cyberpunk', 'neon': 'neon', 'retrò': 'retro', 'retro': 'retro',
  'guerriero': 'warrior', 'samurai': 'samurai', 'ninja': 'ninja', 'pirata': 'pirate',
  'mago': 'wizard', 'fata': 'fairy', 'fantasma': 'ghost', 'teschio': 'skull',
};

const ES_DICT = {
  // Articles/prepositions
  'un ': 'a ', 'una ': 'a ', 'el ': 'the ', 'la ': 'the ', 'los ': 'the ', 'las ': 'the ',
  'y ': 'and ', 'con ': 'with ', 'en ': 'in ', 'de ': 'of ', 'del ': 'of the ', 'al ': 'at the ',
  // Common art/design words
  'gato': 'cat', 'perro': 'dog', 'caballo': 'horse', 'lobo': 'wolf', 'zorro': 'fox',
  'dragón': 'dragon', 'dragon': 'dragon', 'tigre': 'tiger', 'león': 'lion', 'leon': 'lion',
  'águila': 'eagle', 'aguilal': 'eagle', 'búho': 'owl', 'buho': 'owl',
  'oso': 'bear', 'ciervo': 'deer', 'conejo': 'rabbit', 'delfín': 'dolphin', 'delfin': 'dolphin',
  'montaña': 'mountain', 'montana': 'mountain', 'bosque': 'forest', 'mar': 'sea', 'océano': 'ocean', 'oceano': 'ocean',
  'cielo': 'sky', 'sol': 'sun', 'luna': 'moon', 'estrella': 'star', 'noche': 'night',
  'fuego': 'fire', 'agua': 'water', 'hielo': 'ice', 'nube': 'cloud', 'viento': 'wind',
  'flor': 'flower', 'rosa': 'rose', 'árbol': 'tree', 'arbol': 'tree', 'jardín': 'garden', 'jardin': 'garden',
  'ciudad': 'city', 'calle': 'street', 'puente': 'bridge', 'castillo': 'castle', 'torre': 'tower',
  'robot': 'robot', 'nave espacial': 'spaceship', 'galaxia': 'galaxy',
  'rojo': 'red', 'azul': 'blue', 'verde': 'green', 'negro': 'black', 'blanco': 'white',
  'dorado': 'golden', 'morado': 'purple', 'naranja': 'orange',
  'hermoso': 'beautiful', 'hermosa': 'beautiful', 'grande': 'large', 'pequeño': 'small', 'pequeno': 'small',
  'antiguo': 'ancient', 'moderno': 'modern', 'futurista': 'futuristic', 'mágico': 'magical', 'magico': 'magical',
  'oscuro': 'dark', 'brillante': 'bright', 'colorido': 'colorful',
  'artístico': 'artistic', 'artistico': 'artistic', 'detallado': 'detailed',
  'cyberpunk': 'cyberpunk', 'neón': 'neon', 'neon': 'neon', 'retro': 'retro',
  'guerrero': 'warrior', 'samurai': 'samurai', 'ninja': 'ninja', 'pirata': 'pirate',
  'mago': 'wizard', 'hada': 'fairy', 'fantasma': 'ghost', 'cráneo': 'skull', 'craneo': 'skull',
};

// ── Language detector (heuristics) ───────────────────────────────────────────

// Words that strongly indicate each language (exclude words common in other languages)
const LANG_SIGNALS = {
  fr: ['chat', 'chien', 'loup', 'renard', 'montagne', 'forêt', 'foret', 'nuit', 'soleil',
       'lune', 'étoile', 'feu', 'fleur', 'ville', 'château', 'chateau', 'sombre',
       'guerrier', 'sorcier', 'crâne', 'crane', 'avec', 'dans', 'sur', 'un ', 'une ', 'les '],
  de: ['katze', 'hund', 'wolf', 'fuchs', 'berg', 'wald', 'nacht', 'sonne', 'mond',
       'stern', 'feuer', 'blume', 'baum', 'stadt', 'schloss', 'dunkel', 'krieger',
       'zauberer', 'schädel', 'schaedel', 'mit ', 'und ', 'der ', 'die ', 'das '],
  it: ['gatto', 'cane', 'lupo', 'volpe', 'montagna', 'foresta', 'notte', 'sole',
       'luna', 'stella', 'fuoco', 'fiore', 'albero', 'città', 'citta', 'castello',
       'scuro', 'guerriero', 'mago', 'teschio', 'con ', 'nel ', 'della ', 'dello '],
  es: ['gato', 'perro', 'lobo', 'zorro', 'montaña', 'montana', 'bosque', 'noche',
       'fuego', 'flor', 'árbol', 'arbol', 'ciudad', 'castillo', 'oscuro', 'guerrero',
       'cráneo', 'craneo', 'con ', 'del ', 'los ', 'las ', 'una '],
};

const LANG_NAMES = { fr: 'French', de: 'German', it: 'Italian', es: 'Spanish' };

/**
 * Detect the language of a prompt. Returns null if likely English.
 * @param {string} prompt
 * @returns {{ lang: string, name: string } | null}
 */
export function detectLanguage(prompt) {
  const lp = ' ' + prompt.toLowerCase().trim() + ' ';
  const scores = {};
  for (const [lang, signals] of Object.entries(LANG_SIGNALS)) {
    scores[lang] = signals.filter(sig => lp.includes(sig)).length;
  }
  const best = Object.entries(scores).sort((a, b) => b[1] - a[1])[0];
  if (!best || best[1] === 0) return null;
  return { lang: best[0], name: LANG_NAMES[best[0]] };
}

/**
 * Translate a prompt using the hardcoded dictionary for the detected language.
 * Returns the translated string (best-effort word substitution).
 * @param {string} prompt
 * @param {string} lang - 'fr' | 'de' | 'it' | 'es'
 * @returns {string}
 */
export function translatePrompt(prompt, lang) {
  const dict = { fr: FR_DICT, de: DE_DICT, it: IT_DICT, es: ES_DICT }[lang];
  if (!dict) return prompt;

  let result = ' ' + prompt.toLowerCase().trim() + ' ';

  // Multi-word phrases first
  const entries = Object.entries(dict).sort((a, b) => b[0].length - a[0].length);
  for (const [src, tgt] of entries) {
    result = result.split(src).join(tgt + ' ');
  }

  // Clean up: collapse double spaces, trim, capitalize first letter
  result = result.replace(/\s{2,}/g, ' ').trim();
  return result.charAt(0).toUpperCase() + result.slice(1);
}
